import {useMutation} from "@tanstack/react-query";

import {createSupplierMutationOptions} from "./create-supplier.mutation-options";

export function useCreateSupplier() {
  return useMutation(createSupplierMutationOptions());
}
